<template>
  <section class="gamanza-experience-panel" :style="panelStyle">
    <div class="gamanza-experience-panel__header">
      <span class="gamanza-experience-panel__mark"><i class="fas fa-trophy" aria-hidden="true"></i></span>
      <div>
        <strong>Mi experiencia</strong>
        <small>Tu perfil, beneficios y progreso</small>
      </div>
    </div>

    <div class="gamanza-experience-panel__stats">
      <div v-for="stat in statWidgets" :key="stat.key" class="gamanza-experience-panel__stat"
        :class="`gamanza-experience-panel__stat--${stat.key}`">
        <span>{{ stat.label }}</span>
        <div :id="stat.id" class="gamification_widget" data-type="gamification-data"
          :data-gamification-type="stat.gamificationType" :data-show-name="stat.showName"
          :data-progress-type="stat.progressType"></div>
      </div>
    </div>

    <div class="gamanza-experience-panel__actions">
      <button v-if="showMissions" type="button" @click="$emit('navigate-gamanza-page', 'gamanza_missions')">
        <i class="fas fa-tasks"></i><span>Misiones</span><i class="fas fa-chevron-right"></i>
      </button>
      <button v-if="showTournaments" type="button" @click="$emit('navigate-gamanza-page', 'gamanza_tournaments')">
        <i class="fas fa-trophy"></i><span>Torneos</span><i class="fas fa-chevron-right"></i>
      </button>
      <button v-if="showRewardShop" type="button" @click="$emit('navigate-gamanza-page', 'gamanza_reward_shop')">
        <i class="fas fa-gift"></i><span>Tienda de recompensas</span><i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </section>
</template>

<script>
import gamanzaWidgetService from '@/services/gamanzaWidgetService';

import {
  createGamanzaProfileStatWidgets,
  getGamanzaProfilePalette
} from '../../utils/gamanzaProfileDropdown';

export default {
  name: 'GamanzaExperiencePanel',
  props: {
    skin: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      statWidgets: createGamanzaProfileStatWidgets(`experience-${this._uid}`)
    };
  },
  computed: {
    showMissions() {
      return Boolean(this.skin?.gamanza?.mainFrame?.missions);
    },
    showTournaments() {
      return Boolean(this.skin?.gamanza?.mainFrame?.tournaments);
    },
    showRewardShop() {
      return Boolean(this.skin?.gamanza?.mainFrame?.rewardShop);
    },
    panelStyle() {
      const palette = getGamanzaProfilePalette(this.skin);
      const mobileBackground = this.skin?.gamanza?.mainFrame?.profileDropdown?.mobile?.background;
      const mobilePanelBorderRadius = this.skin?.gamanza?.mainFrame?.profileDropdown?.mobile?.panelBorderRadius;
      return {
        '--gamanza-primary': palette.primary,
        '--gamanza-primary-rgb': palette.primaryRgb,
        '--gamanza-secondary': palette.secondary,
        '--gamanza-contrast': palette.contrastText,
        '--gamanza-surface': mobileBackground || palette.surface,
        '--gamanza-mobile-panel-radius': mobilePanelBorderRadius || '0',
        '--gamanza-text': palette.text
      };
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.statWidgets.forEach((stat) => gamanzaWidgetService.reloadOne(stat.id));
      }, 300);
    });
  }
};
</script>

<style scoped>
.gamanza-experience-panel {
  display: grid;
  gap: 13px;
  margin-top: 13px;
  padding: 16px 18px;
  border: 1px solid rgba(var(--gamanza-primary-rgb), .55);

  background: var(--gamanza-surface);
  color: var(--gamanza-text);
}

.gamanza-experience-panel__header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.gamanza-experience-panel__header > div {
  display: grid;
  gap: 2px;
}

.gamanza-experience-panel__header strong {
  font-size: 14px;
  text-transform: uppercase;
}

.gamanza-experience-panel__header small {
  color: var(--gamanza-secondary);
  font-size: 10px;
  font-weight: 700;
}

.gamanza-experience-panel__mark {
  display: grid;
  width: 30px;
  height: 30px;
  place-items: center;
  border-radius: 50%;
  border: 1px solid rgba(255, 226, 112, .85);
  background: radial-gradient(circle at 30% 24%, #fff8c9 0 11%, #ffd45a 34%, #c57a00 74%, #804300 100%);
  box-shadow: 0 3px 12px rgba(255, 190, 26, .45), inset 0 1px 1px rgba(255, 255, 255, .75);
  color: #713800;
  font-size: 15px;
}

.gamanza-experience-panel__mark i {
  filter: drop-shadow(0 1px 0 rgba(255, 255, 255, .45));
}

.gamanza-experience-panel__stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
  padding: 9px;
  border: 1px solid rgba(var(--gamanza-primary-rgb), .35);
  border-radius: 10px;
}

.gamanza-experience-panel__stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  font-size: 9px;
  font-weight: 700;
  text-align: center;
}

.gamanza-experience-panel__stat--xp {
  align-items: stretch;
  grid-column: 1 / -1;
}

.gamanza-experience-panel__stat > span {
  display: block;
  margin-bottom: 3px;
  color: var(--gamanza-secondary);
  text-transform: uppercase;
}

.gamanza-experience-panel__stat .gamification_widget {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 24px;
  overflow: hidden;
}

.gamanza-experience-panel__actions {
  display: grid;
  gap: 7px;
}

.gamanza-experience-panel__actions button {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 35px;
  gap: 10px;
  padding: 0 9px;
  border: 1px solid transparent;
  border-radius: 7px;
  background: transparent;
  color: inherit;
  font-size: 11px;
  font-weight: 800;
  text-align: left;
}

.gamanza-experience-panel__actions button:hover {
  border-color: var(--gamanza-primary);
  background: rgba(var(--gamanza-primary-rgb), .12);
}

.gamanza-experience-panel__actions i:first-child {
  width: 18px;
  color: var(--gamanza-secondary);
  text-align: center;
}

.gamanza-experience-panel__actions i:last-child {
  margin-left: auto;
  color: var(--gamanza-secondary);
}

@media (max-width: 799px) {
  .gamanza-experience-panel {
    border: 0;
    border-radius: var(--gamanza-mobile-panel-radius);
  }
}
</style>
